import React from 'react';
import { useAuth } from 'react-oidc-context';
import {
  Content,
  EmptyState,
  EmptyStateBody,
  Icon,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
  Breadcrumb,
  BreadcrumbItem,
} from '@patternfly/react-core';
import { HeadsetIcon } from '@patternfly/react-icons';
import Unauthenticated from '@app/Unauthenticated';

function Support() {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return <Unauthenticated />;
  }

  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem isActive>Support</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection hasBodyWrapper variant={PageSectionVariants.default} isWidthLimited hasShadowBottom={true}>
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <HeadsetIcon />
          </Icon>
          Support
        </Content>
        <Content component="p">Get help and contact our support team</Content>
      </PageSection>
      <PageSection hasBodyWrapper={false}>
        <EmptyState titleText="Coming soon" icon={HeadsetIcon} variant="lg" headingLevel="h2">
          <EmptyStateBody>The support portal is not yet available.</EmptyStateBody>
        </EmptyState>
      </PageSection>
    </>
  );
}

export { Support };
